module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_0.4b290945.png";